import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {ActivatedRoute, Router} from '@angular/router';
import {HeadersComponent} from '../devex/headers/headers.component';
import {ExecutorComponent} from '../executor/executor.component';
import {Observable} from 'rxjs';
import {ICategory} from '../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import {environment} from '../../environments/environment';
import {KongService} from '../kong.service';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {PartnerOnboardComponent} from '../partner-onboard/partner-onboard.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ListenerService} from '../listener.service';
import {SqlqueryListenerService} from '../sqlquery-listener.service';
import exportFromJSON from 'export-from-json';
import {Location} from '@angular/common';
import {WebsocketService} from '../websocket.service';
import {AuditListenerService} from '../audit-listener.service';
import {DependencyCheckComponent} from '../new-blockly/new-blockly.component';
import {TestReportComponent} from '../testsuite/test-report/test-report.component';
import {QueryBuilderConfig} from 'angular2-query-builder';
import {MAT_DIALOG_DATA, MatCheckboxChange, MatDialog, MatDialogRef, MatTabGroup} from '@angular/material';
import {JsonEditorOptions} from 'ang-jsoneditor';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { Orientation, TourStep } from 'ngx-guided-tour';
import {AuditLogService} from '../audit-log.service';

declare let $;
const incr = 5;


@Component({
    selector: 'app-query-builder',
    templateUrl: './query-builder.component.html',
    styleUrls: ['./query-builder.component.css']
})
export class QueryBuilderComponent implements OnInit {
    apiList = [];
    apiList_copy = [];
    apiList1 = [];
    apiList2 = [];
    apiList3 = [];
    selectedApis: any = [];

    viewSearchAPI = true;
    searchAPI = '';
    viewSearchGroupBy = true;
    searchGroupBy = '';
    viewSearchOrderBy = true;
    searchOrderBy = '';
    viewSearchFieldBy = true;
    searchFieldBy = '';
    query = {
        condition: 'and',
        rules: [
            /*{field: 'age', operator: '=', value: ''}*/
        ]
    };
    query1 = {
        condition: 'and',
        rules: [
            /*{field: 'age', operator: '=', value: ''}*/
        ]
    };
    config: QueryBuilderConfig;
    config1: QueryBuilderConfig;
    attributeList: any = [];
    ruleset = {
        'condition': 'and',
        'rules': [
            {
                'attributes': null,
                'functions': null,
                'operators': null,
                'values': null
            }]
    };
    queryRuleset = {
        'condition': 'and',
        'rules': [
            {
                'field': null,
                'type': null,
                'function': null,
                'operator': null,
                'value': null
            }]
    };
    title = 'app';
    code = '';
    showNextPanel = false;
    theme = 'vs-dark';
    options = {
        theme: this.theme,
        language: 'sql',
        automaticLayout: true
    };
    @Input() enableEditor = false;
    database: string;
    tableSelected: string;
    databaseList = [];
    dbItem: any;
    dbs: any;
    fields: any;
    attribute: string;
    databaseName: string;
    selectedIndex: any;
    filterData: any[];
    settings = {
        text: 'Select APIs',
        enableSearchFilter: true,
        autoPosition: false
    };
    itemList: any[];
    error = false;
    errorMessage: string;
    searchText: any;

    logVisible = false;
    refreshLogCount = 0;
    pubSubTopic: any;
    logComponentRefresh = false;
    apiDeploymentLogs = [];
    currentMessage: any;
    apiType = 'UNIFIEDQUERY';
    logTimeStamp: any;

    responseCode: any;
    responseData: any;
    responseItems: any;
    responses: any;
    databaseFlag = false;
    responseError: any;
    responseTimestamp: any;
    responseHeaders: any;
    responseTime: any;
    userView = 'json';
    columns: string[] = [];
    itemLength: any;
    showDialogOnNonWebsocketConnection: any;


    authModel = {
        'authType': '',
        'authAttributes': {}
    };
    headers = [];
    @Input() mockResponses = [];
    queryParams = [];
    requestBody: any;
    prerequisites: any;
    responseAttributes = [];

    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    scopeSelected = 'public';
    description: string;
    executorCategory: string;
    @Input() executor_name: string;
    @Input() selectedVersion: string;
    selectedExecutorType: string;
    selectedExecutor: string;
    executor_display_name: string;
    defaultApijoinsOptions = {
        editEnabled: false,
        deleteEnabled: false,
        approvalRequired: false,
        approvalType: 'single',
        minimumApprovals: 1,
        approvers: []
    };
    apijoinsOptions = {};
    gatewayUrl: any;
    gatewayFullUrl: string;
    executorModel: any;
    executorModelPayload: any;
    @Input() partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    @Input() account_id = localStorage.getItem('account');
    @Input() showButtons = true;
    @Input() executorModelAvailable = false;
    @Input() executorModelInput: any;
    @Input() disableDatabase = false;
    @Input() fromCopyOrPromote = false;
    @Input() targetDatabases = [];
    @Input() targetPartner: any;
    @Input() targetAccount: any;
    @Input() targetPkey: any;
    @Input() retrieveExecutorFromRouteParams = true;
    @Output() onSavingExecutor: EventEmitter<any> = new EventEmitter<any>();
    apiKey = localStorage.getItem('apikey');
    executor: any;
    pathParams: any;
    save: boolean;
    filteredOptions: Observable<ICategory[]>;
    myControl = new FormControl();
    destroy: any;
    Blocks = [];
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progress = 0;
    progressMessage: string;
    editFlag: boolean;
    loading = false;
    @ViewChild(ExecutorComponent) executorComp: ExecutorComponent;
    @ViewChild('aceEditor') editor;
    eventNameForAudit = '';
    previousSavedData: any;

    origEntity: string;
    origVersion: string;
    cloneable = false;
    previouslyDeployedData: any;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIAlreadyPresent = true;
    orig_executor_name: any;
    orig_executor: any;
    orig_executor_version: any;
    componentLoading = true;
    selectedDatatypeFilter: string;
    isSelectedDatabaseNatureNoSQL: any;
    databases: any;
    fromHistory = false;
    action: any;
    eventNameForAuditLog = '';
    eventLabelForAuditLog = '';
    connection: any;
    redeployNewExecutor = false;
    isSqlPresent = false;
    gatewaySettings: any;
    gatewayControl = new FormControl([]);


    dependencyApis: any;
    testLoading = false;
    testSuiteResponse: any;


    tableList: any;
    method: string;
    entityList: any;
    enablequery: boolean;
    enablequery1: boolean;
    enableQuerySection: boolean;

    level = [{'displayName': 'Only ' + localStorage.getItem('account'), 'value': 'account', 'checked': true},
        {'displayName': 'All Accounts', 'value': 'partner', 'checked': false}];

    url = environment.konghost;

    version = 'v1';


    isLinear = true;
    @Input() account = localStorage.getItem('account');
    @Input() executor_version = '';
    testCasesSearchText: any;
    parameters = [];
    count = 0;

    httpOperation: any;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    httpUrl: string;
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    formData = [];
    requestBodySelected = 'none';
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];

    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild('tabref4') tabref4: MatTabGroup;
    @Output() onCompletingTestCases: EventEmitter<any> = new EventEmitter<any>();

    options1 = new JsonEditorOptions();

    showPathParameters: boolean;
    devExURL = '';
    isCountOfResAtt: boolean;
    pathParameterSegregator: any;
    find: any;
    pathParameterStopper: any;
    pathParameterValue: any;

    rawRequestBody: any;

    authAttributes = {};


    formDataTrue = true;
    formURLEncodedTrue = true;


    executorName: string;
    executorVersion: string;
    executor_url: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    apiByDefinition: any;
    categories: any;
    entities = [];

    basicPermission: boolean;
    DisplayApiByCategory = true;

    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    workFlowExecutors: any;

    apisByCategory: any;
    dataAccess = [];
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];

    DisplayCustomOperation = true;

    showAPIBrowser = true;
    showResponseSection = false;
    responseType: any;
    returnType = '';
    executeFlag: any;
    responseText: any;
    viewResult = true;
    executorForApi = {};


    subscriberColumns = [];
    subscribersColumnsLength: number;
    subscribersData: any;
    selectAll = false;
    subscribersChecked = [];
    settingsData: any;
    @Input() testcase = [];
    @Output() onAddingTestCase: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCompletingTearDownSteps: EventEmitter<any> = new EventEmitter<any>();
    Index = 0;
    currentTestCaseName = '';
    currentTestCaseIndex = 0;
    assert = [];
    steps = {};
    leftOperand = [
        {
            name: 'response',
            value: ''
        },
        {
            name: 'response.body',
            value: ''
        },
        {
            name: 'response.statusCode',
            value: ''
        },
        {
            name: 'response.headers',
            value: ''
        },
    ];
    leftOperandString: string;
    rightOperand;
    operators = ['=', '≠', '<', '≤', '>', '≥'];
    selectedAttribute: any;
    selectedAttributeType: any;
    selectedAttribute1: any;
    selectedAttributeType1: any;
    selectedAttribute2: any;
    selectedAttributeType2: any;

    availableAttributeList = [];
    availableAttributeList1 = [];
    availableAttributeList2 = [];
    groupByList = [];
    orderByList = [];
    projectionAttributeList = [];

    apiProperties = {};

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    selectedTab = 0;
    selectedBQTab: any;

    constructor(
        private settingComp: PartnerOnboardComponent,
        private router: Router,
        private confPost: ConfService,
        private _service: ConnecttocrudService,
        private appComp: AppComponent,
        private route: ActivatedRoute,
        private kongService: KongService,
        public platform: LeftpanelComponent,
        private websocketService: WebsocketService,
        private leftPanelDataListener: ListenerService,
        private auditListenerService: AuditListenerService,
        private SQLQueryListenerInstance: SqlqueryListenerService,
        private dialog: MatDialog, private auditLog: AuditLogService,
        private location: Location) {

        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /*this.editor.get()*/);

        this.config = {
            fields: {}
        };
        this.config1 = {
            fields: {}
        };


    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        if (this.location['_platformLocation'].location.pathname === '/unified-query-builder') {
            this.editFlag = false;
            this.route.queryParams
                .subscribe(async params => {

                    if (params.entity != null && params.version || this.fromCopyOrPromote) {
                        this.editFlag = true;
                        this.orig_executor_name = params.entity;
                        this.orig_executor_version = params.version;
                        this.origEntity = params.entity;
                        this.origVersion = params.version;
                        this.partner = params.partner;
                        this.account_id = params.account;
                        this.showNextPanel = false;
                        this.save = false;
                        this.executor_name = params.entity;
                        this.selectedVersion = params.version;

                        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion).subscribe(exec => {
                            const temp: any = exec;
                            if (exec) {
                                this.selectedExecutor = temp['executor_method_type'];
                                this.executorCategory = temp['executor_category'];
                                this.selectedExecutorType = temp['executor_type'];
                                if (temp['gatewaySettings']) {
                                    this.gatewaySettings = temp['gatewaySettings'];
                                    const gateways = [];
                                    if (this.gatewaySettings) {
                                        if (this.gatewaySettings.length > 0) {
                                            for (const gateway of this.gatewaySettings) {
                                                gateways.push(gateway['name']);
                                            }
                                        }
                                    }
                                    if (gateways.length === 0) {
                                        gateways.push('default');
                                    }
                                    this.gatewayControl.setValue(gateways); // To trigger change detection
                                }
                                if (temp['properties']) {
                                    this.apiProperties = Object.assign({}, temp['properties']);
                                    if (temp['properties']['apijoinsOptions']) {
                                        this.apijoinsOptions = Object.assign({}, temp['properties']['apijoinsOptions']);
                                    }
                                }
                                if (temp['executors'].length > 0) {

                                    for (const item of temp['executors'][0]['executors']) {
                                        this.addTestCase(item);
                                    }
                                    this.projectionAttributeList = temp['executors'][0]['fields'];
                                    this.query1 = temp['executors'][0]['join'];
                                    this.groupByList = temp['executors'][0]['groupby'];
                                    this.query = temp['executors'][0]['condition_org'];
                                    this.orderByList = temp['executors'][0]['orderby_org'];

                                }

                            }

                        });
                    } else {
                        this.executor = undefined;
                        this.executor_name = undefined;
                        this.selectedVersion = undefined;
                        this.selectedExecutorType = undefined;
                        this.selectedExecutor = undefined;
                        this.executorCategory = undefined;
                        this.executor_display_name = undefined;
                        this.description = undefined;
                        this.queryParams = [];
                        this.pathParams = undefined;
                        this.headers = [];
                        this.mockResponses = [];
                        this.requestBody = {};
                        this.executorModel = undefined;
                        this.database = undefined;
                        // this.databaseSelected = this.database.db_name;
                        this.code = '';
                        this.showNextPanel = false;
                        this.save = false;
                        this.projectionAttributeList = [];
                        this.orderByList = [];
                        this.groupByList = [];
                        this.availableAttributeList = [];
                        this.availableAttributeList1 = [];
                        this.availableAttributeList2 = [];
                        this.query = {
                            condition: 'and',
                            rules: []
                        };
                        this.query1 = {
                            condition: 'join',
                            rules: []
                        };
                        this.testcase = [];
                        this.resetAttributes();
                    }
                });
        }


        // if (this.executorModelAvailable) {
        //     const executor = JSON.parse(JSON.stringify(this.executorModelInput));
        //     this.executor_name = executor.executor_name;
        //     this.orig_executor_name = executor.executor_name;
        //     this.orig_executor_version = executor.executor_version;
        //     this.selectedVersion = executor.executor_version;
        //     this.selectedExecutorType = executor.executor_type;
        //     this.selectedExecutor = executor.executor_method_type;
        //     this.executorCategory = executor.executor_category;
        //     this.executor_display_name = executor.executor_display_name;
        //     this.description = executor.executor_description;
        //     this.queryParams = executor.queryParams ? executor.queryParams : [];
        //     this.pathParams = executor.pathParams ? executor.pathParams : [];
        //     this.headers = executor.headers;
        //     this.requestBody = executor.requestBody;
        //     this.scopeSelected = executor.scopeOfAccess ? executor.scopeOfAccess : executor.executor_scope;
        //     if (executor.executors) {
        //         this.executorModel = executor.executors[0];
        //         if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
        //             this.database = this.executorModel.database.databaseDetails.database_name;
        //         } else {
        //             this.database = this.executorModel.database.database_name;
        //         }
        //         this.code = this.executorModel.query;
        //     }
        // }
        //
        //
        // this.databaseList.push({'db_name': 'inherit', 'db_type': 'inherit'});
        // this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        // this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        //
        // this.appComp.currentPageTitle = 'Generate API from SQL Query';
        // this.enableEditor = true;
        //
        // const getAttributesForQueryBuilder = new Promise(async (resolve, reject) => {
        //     if (!this.cloneable) {
        //         if (this.platform.queryBuilderAttributes !== null && this.platform.queryBuilderAttributes !== undefined) {
        //             this.databaseFlag = true;
        //             this.dbItem = this.platform.queryBuilderAttributes;
        //             this.dbs = this.dbItem.body[0];
        //             resolve('success');
        //         } else {
        //             await this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
        //                 this.databaseFlag = true;
        //                 this.dbItem = db;
        //                 this.platform.queryBuilderAttributes = db;
        //                 this.dbs = this.dbItem.body[0];
        //                 resolve('success');
        //             }, error => {
        //                 resolve('failed');
        //                 this.platform.handleErrorGracefully(error, 'Error while retrieving attributes for query builder. Please try again after sometime.');
        //             });
        //         }
        //     } else {
        //         resolve('success');
        //     }
        // });
        //
        // const getDatabases = new Promise(async (resolve, reject) => {
        //     if (this.platform.databases !== null && this.platform.databases !== undefined) {
        //         let response: any;
        //         let databases = [];
        //         await this.platform.updateIsNoSQLForMongo(this.platform.databases);
        //         response = this.platform.databases;
        //         if (response.hasOwnProperty('databaseDetails')) {
        //             databases = response['databaseDetails'];
        //         } else {
        //             databases = response;
        //         }
        //         databases.forEach((dblist) => {
        //             if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
        //                 this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
        //             }
        //         });
        //         resolve('success');
        //     } else {
        //         await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async data => {
        //                 let response: any;
        //                 let databases = [];
        //                 await this.platform.updateIsNoSQLForMongo(data);
        //                 response = this.platform.databases;
        //                 if (response.hasOwnProperty('databaseDetails')) {
        //                     databases = response['databaseDetails'];
        //                 } else {
        //                     databases = response;
        //                 }
        //                 databases.forEach((dblist) => {
        //                     if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
        //                         this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
        //                     }
        //                 });
        //                 resolve('success');
        //             },
        //             error => {
        //                 resolve('failed');
        //                 this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
        //             });
        //     }
        // });
        //
        // Promise.all([getAttributesForQueryBuilder, getDatabases]).then(resp => {
        // });
        this.componentLoading = false;
        this.getThirdPartyApiExecutorsByPartnerAccountType();
        this.basicPermission = true;
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            for (let i = 0; i < this.categories.length; i++) {
                                for (let j = 0; j < this.categories[i].entities.length; j++) {
                                    const tempJSON = {};
                                    tempJSON['entity'] = this.getEntity(this.categories[i].entities[j]);
                                    tempJSON['version'] = this.getVersion(this.categories[i].entities[j]);
                                    this.entities.push(tempJSON);
                                }
                            }
                        }
                    });
                }
            });

        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];

        this.Index = 0;
        for (const header of this.headersData) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
        if (this.testcase.length) {
            this.setCurrentTestCase(this.currentTestCaseIndex);
        }

        this.platform.setGuideTourSteps(this.getAPIQueryBuilderTourSteps());

    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false && this.location['_platformLocation'].location.pathname === '/querybuilder') {
            this.confPost.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    hasViewPagePermissions() {
        if (this.editFlag === true) {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_UNIFIED_QUERY_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
            } else {
                return this.platform.hasPermissions(['EDIT_UNIFIED_QUERY_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
            }
        } else {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_UNIFIED_QUERY_API']));
            } else {
                return this.platform.hasPlatformPermission('CREATE_UNIFIED_QUERY_API');
            }
        }
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.websocketService.isOpen()) {
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    hasSavePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SAVE_UNIFIED_QUERY_API', 'save:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SAVE_UNIFIED_QUERY_API');
        }
    }

    hasCopyPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['COPY_UNIFIED_QUERY_API', 'copy:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('COPY_UNIFIED_QUERY_API');
        }
    }

    async getDatabasesFilter(val) {
        return new Promise(async (resolve, reject) => {
            if (this.platform.databases !== null && this.platform.databases !== undefined) {
                await this.platform.updateIsNoSQLForMongo(this.platform.databases);
                this.databases = this.platform.databases;
                this.databases.filter(items => {
                    if (items.database_name === val) {
                        this.selectedDatatypeFilter = items.database_type;
                        if (items.hasOwnProperty('is_nosql')) {
                            this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                        }
                    }
                });
                resolve('success');
            } else {
                await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                        await this.platform.updateIsNoSQLForMongo(databases);
                        this.databases = this.platform.databases;
                        this.databases.filter(items => {
                            if (items.database_name === val) {
                                this.selectedDatatypeFilter = items.database_type;
                                if (items.hasOwnProperty('is_nosql')) {
                                    this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                                }
                            }
                        });
                        resolve('success');
                    },
                    error => {
                        this.platform.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        reject(error);
                    });
            }
        });
    }

    async copyTo() {
        if (this.executor && this.executor !== null && this.executor !== undefined) {
            const metaSchema = JSON.parse(JSON.stringify(this.executor));
            await this.getDatabasesFilter(this.database);
            metaSchema['databaseType'] = this.selectedDatatypeFilter;
            this.platform.copyToPartner(this.executor['executor_name'], this.executor['executor_version'], 'SQLQUERY', metaSchema);
        }
    }

    addRule(data) {
        const newRule = {
            'attributes': null,
            'functions': null,
            'operators': null,
            'values': null
        };
        data.rules.push(newRule);
    }

    saveEmitAPI() {
        this.executorModelPayload = this.getAPIExecutorModelForSQLQuery(this.executorModel);
        this.executorModelPayload.executors[0].query = this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null;
        this.onSavingExecutor.emit(this.executorModelPayload);
    }

    emitAPI() {
        this.onSavingExecutor.emit(this.executorModel);
    }

    getProjectionData(data) {
        const result = {};
        result['include_fields'] = [];
        result['exclude_fields'] = [];
        data.forEach((proj) => {
            const sun_res = {};
            sun_res['table_name'] = '';
            sun_res['table_alias'] = '';
            sun_res['attribute'] = proj;
            sun_res['attribute_alias'] = '';
            sun_res['aggregate_function'] = '';
            result['include_fields'].push(sun_res);
        });
        return result;
    }

    getCollectionsData(data) {
        const result = {};
        result['table_name'] = data;
        return result;
    }

    checkFilter() {
        if (this.filterData === null || this.filterData === undefined || this.filterData === []) {
            this.searchText = '';
            alert('Please select and attribute to filter.');
        }
    }

    removeRule(data, i) {
        data.splice(i, 1);
    }

    getApiExecutorByPartnerAccountByNameAndVersion(partner, account, executorName, executorVersion) {
        return new Promise((resolve, reject) => {
            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(partner, account, executorName, executorVersion).subscribe(exec => {
                this.executor = exec;
                if (this.executor) {
                    this.orig_executor = exec;
                    this.executor_name = this.executor.executor_name;
                    this.selectedVersion = this.executor.executor_version;
                    this.selectedExecutorType = this.executor.executor_type;
                    this.selectedExecutor = this.executor.executor_method_type;
                    this.executorCategory = this.executor.executor_category;
                    this.executor_display_name = this.executor.executor_display_name;
                    this.description = this.executor.executor_description;
                    this.queryParams = this.executor.queryParams;
                    this.pathParams = this.executor.pathParams;
                    this.headers = this.executor.headers;
                    this.mockResponses = this.executor.mockResponses;
                    this.requestBody = this.executor.requestBody;
                    this.executorModel = this.executor.executors[0];
                    this.scopeSelected = this.executor.scopeOfAccess;
                    if (this.executorModel) {
                        if (this.executorModel.database) {
                            if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
                                this.database = this.executorModel.database.databaseDetails.database_name; //{'db_name': this.executorModel.database.database_name, 'db_type': this.executorModel.database.database_type};
                            } else {
                                this.database = this.executorModel.database.database_name;
                            }
                        }
                        if (this.executorModel.hasOwnProperty('query')) {
                            this.code = this.executorModel.query;
                        }
                    }
                    if (this.executor.responseAttributes !== null) {
                        this.responseAttributes = this.executor.responseAttributes;
                    }
                }
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    async getDatabases() {
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            let response: any;
            let databases = [];
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            response = this.platform.databases;
            if (response.hasOwnProperty('databaseDetails')) {
                databases = response['databaseDetails'];
            } else {
                databases = response;
            }
            databases.forEach((dblist) => {
                if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                    this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                }
            });
        } else {
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async data => {
                    let response: any;
                    let databases = [];
                    await this.platform.updateIsNoSQLForMongo(data);
                    response = this.platform.databases;
                    if (response.hasOwnProperty('databaseDetails')) {
                        databases = response['databaseDetails'];
                    } else {
                        databases = response;
                    }
                    databases.forEach((dblist) => {
                        if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                            this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                        }
                    });
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
        }
    }

    async saveAPI() {

        let saveClickedMessage = '';
        let saveSuccessMessage = '';
        let saveFailureMessage = '';

        if (this.editFlag) {
            saveClickedMessage = 'sqlquery_edit_save_clicked';
            saveSuccessMessage = 'sqlquery_edit_save_success';
            saveFailureMessage = 'sqlquery_edit_save_success';
        } else {
            saveClickedMessage = 'sqlquery_create_save_clicked';
            saveSuccessMessage = 'sqlquery_create_save_success';
            saveFailureMessage = 'sqlquery_create_save_success';
        }

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, saveClickedMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });


        await this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.database).toPromise().then(db => {
            this.executorModel = {
                'database': {},
                'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
            };
            if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                this.executorModel.database['database_name'] = db['database_name'];
                this.executorModel.database['database_type'] = db['database_type'];
            }

            const savePayload = {
                partner: '',
                account: '',
                executor_name: '',
                executor_type: '',
                by: '',
                executor_version: '',
                action: ''
            };

            savePayload.partner = this.partner;
            savePayload.account = this.account_id;
            savePayload['at'] = Date.now();
            savePayload.by = this.partner;

            if (this.executorComp.executor_name !== null && this.executorComp.executor_name !== undefined && this.executorComp.executor_name !== '') {
                savePayload.executor_name = this.executorComp.executor_name;
            } else {
                savePayload.executor_name = Date.now().toString();
            }

            if (this.executorComp.selectedVersion && this.executorComp.selectedVersion !== undefined && this.executorComp.selectedVersion !== null && this.executorComp.selectedVersion !== '') {
                savePayload.executor_version = this.executorComp.selectedVersion;
            } else {
                savePayload.executor_version = 'No Ver.';
            }
            if (this.editFlag) {
                savePayload.action = 'UPDATE';
            } else {
                savePayload.action = 'CREATE';
            }
            savePayload.executor_type = 'SQLQUERY';

            const requestBodyResponse = this.executorComp.getRequestBody();
            let requestBody = {};
            if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
                requestBody = requestBodyResponse['__zone_symbol__value'];
            } else {
                requestBody = requestBodyResponse;
            }


            const executorModel = {
                'executor_type': this.executorComp.selectedExecutorType,
                'executor_name': this.executorComp.executor_name,
                'executor_version': this.executorComp.selectedVersion,
                'executor_display_name': this.executorComp.executor_display_name,
                'executor_description': this.executorComp.description,
                'executor_category': this.executorComp.executorCategory,
                'executor_method_type': this.executorComp.selectedExecutor,
                'published': true,
                'scopeOfAccess': this.executorComp.scopeSelected,
                'creationTime': Date.now(),
                'lastModifiedTime': Date.now(),
                'registeredAsIs': false,
                'queryParams': this.executorComp.queryParams,
                'headers': this.executorComp.headers,
                'mockResponses': this.executorComp.mockResponses,
                'authModel': this.executorComp.authModel,
                'requestBody': requestBody,
                'source': this.code.trim(),
                'executors': [this.executorModel],
                'partner': this.partner,
                'account_id': this.account_id,
                'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
                'dataroot': null,
                'responseAttributes': this.executorComp.responseAttributes,
                'attributeMappings': null,
                'response': null,
                'block_attributes': null
            };

            savePayload['executor'] = executorModel;
            const temp = JSON.parse(JSON.stringify(savePayload['executor']));
            let isSame = true;
            if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
                if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                    const keyArray = Object.keys(this.previousSavedData);
                    for (const key of keyArray) {
                        if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                            continue;
                        } else {
                            isSame = false;
                            break;
                        }
                    }
                } else {
                    isSame = false;
                }
            } else {
                isSame = false;
            }

            if (isSame === false) {
                this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, saveSuccessMessage, 'INFO', data.status, data.statusText, '', executorModel, data, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                    this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
                }, error => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, saveFailureMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), executorModel, error, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            } else {
                this.platform.openSnackBar('No changes to save for this API.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.platform.openSnackBar('Please select a valid Database.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.router.navigateByUrl('/querybuilder');
        });
    }

    getAPIExecutorModelForSQLQuery(SQLExecutorModel: any) {

        const requestBodyResponse = this.executorComp.getRequestBody();
        let requestBody = {};
        if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
            requestBody = requestBodyResponse['__zone_symbol__value'];
        } else {
            requestBody = requestBodyResponse;
        }

        const executorModel = {
            'executor_type': this.executorComp.selectedExecutorType,
            'executor_name': this.executorComp.executor_name,
            'executor_version': this.executorComp.selectedVersion,
            'executor_display_name': this.executorComp.executor_display_name,
            'executor_description': this.executorComp.description,
            'executor_category': this.executorComp.executorCategory,
            'executor_method_type': this.executorComp.selectedExecutor,
            'published': true,
            'scopeOfAccess': this.executorComp.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'queryParams': this.executorComp.queryParams,
            'headers': this.executorComp.headers,
            'mockResponses': this.executorComp.mockResponses,
            'authModel': this.executorComp.authModel,
            'requestBody': requestBody,
            'prerequisites': this.executorComp.prerequisites,
            'source': this.code.trim(),
            'executors': [],
            'partner': this.partner,
            'account_id': this.account_id,
            'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
            'dataroot': null,
            'attributeMappings': null,
            'response': null,
            'block_attributes': null
        };

        return executorModel;
    }

    getQueryCondition() {
        const constructQueryPayLoad = {
            'database_name': this.database['db_name'],
            'database_type': this.database['db_type'],
            'input_format': 'JSON',
            'table_list': this.tableSelected,
            'projections': this.getProjectionData(this.attribute),
            'collections': [this.getCollectionsData(this.tableSelected)],
            'conditions': [this.queryRuleset],
            'sort_by': [],
            'result_format': ['JSON'],
            'group_by': []
        };
        return constructQueryPayLoad;
    }

    getAPIExecutorModelForQuery() {

        const requestBodyResponse = this.executorComp.getRequestBody();
        let requestBody = {};
        if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
            requestBody = requestBodyResponse['__zone_symbol__value'];
        } else {
            requestBody = requestBodyResponse;
        }

        const executorModel = {
            'executor_type': this.executorComp.selectedExecutorType,
            'executor_name': this.executorComp.executor_name,
            'executor_version': this.executorComp.selectedVersion,
            'executor_display_name': this.executorComp.executor_display_name,
            'executor_description': this.executorComp.description,
            'executor_category': this.executorComp.executorCategory,
            'executor_method_type': this.executorComp.selectedExecutor,
            'published': true,
            'scopeOfAccess': this.executorComp.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'queryParams': this.executorComp.queryParams,
            'headers': this.executorComp.headers,
            'mockResponses': this.executorComp.mockResponses,
            'authModel': this.executorComp.authModel,
            'requestBody': requestBody,
            'prerequisites': this.executorComp.prerequisites,
            'source': JSON.stringify(this.queryRuleset),
            'executors': [this.getQueryCondition()],
            'partner': this.partner,
            'account_id': this.account_id,
            'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
            'dataroot': null,
            'responseAttributes': this.executorComp.responseAttributes,
            'attributeMappings': null,
            'response': null,
            'block_attributes': null
        };
        return executorModel;
    }

    async createOrUpdateApi() {
        this.editFlag = true;

        if (this.origEntity === this.executorComp.executor_name && this.origVersion === this.executorComp.selectedVersion) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.getAPIUsagesWithTestsuites(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                this.dependencyApis = response;
                loaderDialog.close();
                const dialogRef = this.dialog.open(DependencyCheckComponent, {
                    width: '60%',
                    height: 'auto',
                    maxHeight: '70vh',
                    data: {
                        executors: this.dependencyApis,
                        executor_name: this.executor_name,
                        executor_version: this.selectedVersion
                    }
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result && result.continue) {
                        this.createApiForSqlQuery(result.mode);
                    }
                });

            }, error => {
                loaderDialog.close();
                this.platform.openSnackBar('Error while fetching the usages of the API. Please try again later.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            const publishdata = {};
            var message = 'Change in entity';
            publishdata['origEntity'] = this.origEntity;
            publishdata['origVersion'] = this.origVersion;
            publishdata['entity'] = this.executorComp.executor_name;
            publishdata['version'] = this.executorComp.selectedVersion;
            publishdata['tableName'] = 'sqlquery';
            publishdata['origCollection'] = 'sqlquery';

            if (this.origEntity !== this.executorComp.executor_name) {
                if (this.origVersion !== this.executorComp.selectedVersion) {
                    message = 'Both the name and version of the SQL Query API have been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                } else {
                    message = 'Name of the SQL Query API has been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                }
            } else {
                if (this.origVersion !== this.executorComp.selectedVersion) {
                    message = 'Version of the SQL Query API has been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                }
            }
            publishdata['message'] = message;
            let entityLength = 0;
            let versionLength = 0;
            for (let i = 0; i < this.executorComp.executor_name.length; i++) {
                if (this.executorComp.executor_name.charCodeAt(i) === 8 || this.executorComp.executor_name.charCodeAt(i) === 32 || (this.executorComp.executor_name.charCodeAt(i) > 64 && this.executorComp.executor_name.charCodeAt(i) < 91) || (this.executorComp.executor_name.charCodeAt(i) > 96 && this.executorComp.executor_name.charCodeAt(i) < 123) || (this.executorComp.executor_name.charCodeAt(i) >= 48 && this.executorComp.executor_name.charCodeAt(i) <= 57)) {
                    entityLength++;
                }
            }

            for (let i = 0; i < this.executorComp.selectedVersion.length; i++) {
                if (this.executorComp.selectedVersion.charCodeAt(i) === 8 || this.executorComp.selectedVersion.charCodeAt(i) === 32 || (this.executorComp.selectedVersion.charCodeAt(i) > 64 && this.executorComp.selectedVersion.charCodeAt(i) < 91) || (this.executorComp.selectedVersion.charCodeAt(i) > 96 && this.executorComp.selectedVersion.charCodeAt(i) < 123) || (this.executorComp.selectedVersion.charCodeAt(i) >= 48 && this.executorComp.selectedVersion.charCodeAt(i) <= 57)) {
                    versionLength++;
                }
            }
            if (entityLength > 0 && versionLength > 0) {
                if (versionLength === this.executorComp.selectedVersion.length && entityLength === this.executorComp.executor_name.length) {
                    if (this.executorComp.isAPIAlreadyPresentCheckCompleted === false) {
                        await this.executorComp.checkForExistingEntityAndExecutor();
                    }

                    if (this.executorComp.isAPIAlreadyPresent === false) {
                        const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                            width: '60%',
                            data: publishdata
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                this.redeployNewExecutor = true;
                                this.createApiForSqlQuery();
                            } else {
                                this.loading = false;
                            }
                        });
                    } else {
                        this.loading = false;
                        this.platform.openSnackBar('An API with the provided name and version already exists..', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.platform.openSnackBar('Special characters are not allowed in version and entity.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            }
        }
    }

    setHeaders() {
        if (this.executorModelPayload.headers) {
            for (let i = 0; i < this.executorModelPayload.headers.length; i++) {
                if (this.executorModelPayload.headers[i]) {
                    if (this.executorModelPayload.headers[i]['key'] === '') {
                        this.executorModelPayload.headers.splice(i, 1);
                    }
                }
            }
        }
        if (this.executorModelPayload.headers.filter(element => element.key === 'pkey').length === 0) {
            this.executorModelPayload.headers.push({
                key: 'pkey',
                value: localStorage.getItem('partnerKey'),
                description: ''
            });
        }
        if (this.executorModelPayload.headers.filter(element => element.key === 'apikey').length === 0) {
            this.executorModelPayload.headers.push({
                key: 'apikey',
                value: localStorage.getItem('apikey'),
                description: ''
            });
        }
    }


    async createOrUpdateApiWithCoreApi(timeStamp, testMode = 'notests') {

        const gateways = this.executorComp.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }

        if (gatewaySettings.length > 0) {

            const requestBodyResponse = this.executorComp.getRequestBody();
            let requestBody = {};
            if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
                requestBody = requestBodyResponse['__zone_symbol__value'];
            } else {
                requestBody = requestBodyResponse;
            }

            const temp = [];
            const tempExecutors = [];
            const tempOrderBy = [];
            for (const item of this.testcase) {
                tempExecutors.push(item['executor']);
            }
            for (const item of this.orderByList) {
                const temp1 = item['name'] + ' ' + item['sortby'];
                tempOrderBy.push(temp1);
            }
            this.executorForApi['executors'] = tempExecutors;
            this.executorForApi['fields'] = this.projectionAttributeList;
            this.executorForApi['join'] = this.query1;
            this.executorForApi['groupby'] = this.groupByList;
            this.executorForApi['orderby'] = tempOrderBy;
            this.executorForApi['condition'] = this.basicRulesetToSQL(this.query);
            this.executorForApi['condition_org'] = this.query;
            this.executorForApi['orderby_org'] = this.orderByList;

            temp.push(this.executorForApi);

            const executorModel = {
                'executor_type': this.executorComp.selectedExecutorType,
                'executor_name': this.executorComp.executor_name,
                'executor_version': this.executorComp.selectedVersion,
                'executor_display_name': this.executorComp.executor_display_name,
                'executor_description': this.executorComp.description,
                'executor_category': this.executorComp.executorCategory,
                'executor_method_type': this.executorComp.selectedExecutor,
                'published': true,
                'scopeOfAccess': this.executorComp.scopeSelected,
                'creationTime': Date.now(),
                'lastModifiedTime': Date.now(),
                'registeredAsIs': false,
                'queryParams': this.executorComp.queryParams,
                'headers': this.executorComp.headers,
                'mockResponses': this.executorComp.mockResponses,
                'authModel': this.executorComp.authModel,
                'requestBody': requestBody,
                'prerequisites': this.executorComp.prerequisites,
                'source': this.code.trim(),
                'executors': temp,
                'partner': this.partner,
                'account_id': this.account_id,
                'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
                'dataroot': null,
                'attributeMappings': null,
                'response': null,
                'block_attributes': null,
                'isDocumentationPublished': true,
                'properties': this.apiProperties,
                'disabled': false,
                'executionLib': null,
                'gatewaySettings': gatewaySettings
            };

            executorModel['properties']['apijoinsOptions'] = this.apijoinsOptions;

            this.logTimeStamp = timeStamp;

            const topic = this.partner + '.' + this.account_id + '.' + this.executorComp.executor_name + '.' + this.executorComp.selectedVersion + '.' + timeStamp.toString() + '.' + this.action;

            const payload = {
                'topic': topic,
                'apiModel': executorModel
            };


            this.pubSubTopic = topic;
            this.listenToApiCreation(topic);
            this.loading = true;

            if (this.websocketService.isOpen()) {
                this.logVisible = true;
            }

            if (!this.websocketService.isOpen()) {
                this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                    data: {
                        message: 'API deployment is under progress. Please don\'t close the window'
                    }
                });
            }


            this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, false, this.editFlag, true, true).toPromise().then(response1 => {

                this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
                const log_payload = {
                    logType: 'INFO',
                    logLevel: 2,
                    slugSearch: '',
                    label: 'BUTTON_CLICK',
                    featureArea: this.platform.auditFeatureArea.apiJoins,
                    resource: this.editFlag ? 'REDEPLOY' : 'DEPLOY',
                    action: 'CLICK',
                    result: 'SUCCESS',
                    payload: payload,
                    responseStatusCode: 200,
                    response: response1,
                    errorMessage: '',
                    logMessage: this.editFlag ? 'API Redeployed Successfully' : 'API Deployed Successfully'
                };
                this.auditLog.log(log_payload);
            }, error => {
                const log_payload = {
                    logType: 'ERROR',
                    logLevel: 2,
                    slugSearch: '',
                    label: 'BUTTON_CLICK',
                    featureArea: this.platform.auditFeatureArea.apiJoins,
                    resource: this.editFlag ? 'REDEPLOY' : 'DEPLOY',
                    action: 'CLICK',
                    result: 'FAIL',
                    payload: payload,
                    responseStatusCode: error.status,
                    response: error,
                    errorMessage: error.message,
                    logMessage: this.editFlag ? 'Error in API Redeployment' : 'Error in API Deployment'
                };
                this.auditLog.log(log_payload);
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
            });

        } else {
            this.loading = false;
            this.closeNonWSDialogBox();
            this.platform.openSnackBar('Please select at least one valid API Gateway.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }


    async createAPI(timeStamp, testMode = 'notests') {
        let action = '';
        if (this.editFlag === true) {
            action = 'redeploy';
        } else {
            action = 'deploy';
        }

        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
            info: 'Checking for special characters in Executor name',
            type: 'initial',
            icon: 'fa fa-newspaper-o'
        }, timeStamp, action);
        Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.executorComp.executor_name)).then(async resp1 => {
            if (resp1 === true) {
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor name',
                    type: 'success',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor version',
                    type: 'initial',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
                Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.executorComp.selectedVersion)).then(async resp2 => {
                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for special characters in Executor version',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, action);

                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    if (resp2 === true) {

                        if (this.testcase.length > 0) {
                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                info: 'Checking for all required fields',
                                type: 'initial',
                                icon: 'fa fa-file-code-o'
                            }, timeStamp, action);
                            if ((this.executorComp && !this.executorComp.executor_name)
                                || (this.executorComp && !this.executorComp.selectedVersion)
                                || (this.executorComp && !this.executorComp.selectedExecutor)
                                || (this.executorComp && !this.executorComp.executorCategory)) {


                                this.loading = false;
                                this.closeNonWSDialogBox();

                                await this.platform.delay(1500);
                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                    info: 'Checking for all required fields',
                                    icon: 'fa fa-file-code-o',
                                    type: 'fatal'
                                }, timeStamp, action);

                            } else {
                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                    info: 'Checking for all required fields',
                                    type: 'success',
                                    icon: 'fa fa-file-code-o'
                                }, timeStamp, action);

                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                    info: 'Generating the API',
                                    icon: 'fa fa-code',
                                    type: 'initial'
                                }, timeStamp, action);
                                let entityLength = 0;
                                let versionLength = 0;

                                for (let i = 0; i < this.executorComp.executor_name.length; i++) {
                                    if (this.executorComp.executor_name.charCodeAt(i) === 8 || this.executorComp.executor_name.charCodeAt(i) === 32 || (this.executorComp.executor_name.charCodeAt(i) > 64 && this.executorComp.executor_name.charCodeAt(i) < 91) || (this.executorComp.executor_name.charCodeAt(i) > 96 && this.executorComp.executor_name.charCodeAt(i) < 123) || (this.executorComp.executor_name.charCodeAt(i) >= 48 && this.executorComp.executor_name.charCodeAt(i) <= 57)) {
                                        entityLength++;
                                    }
                                }

                                for (let i = 0; i < this.executorComp.selectedVersion.length; i++) {
                                    if (this.executorComp.selectedVersion.charCodeAt(i) === 8 || this.executorComp.selectedVersion.charCodeAt(i) === 32 || (this.executorComp.selectedVersion.charCodeAt(i) > 64 && this.executorComp.selectedVersion.charCodeAt(i) < 91) || (this.executorComp.selectedVersion.charCodeAt(i) > 96 && this.executorComp.selectedVersion.charCodeAt(i) < 123) || (this.executorComp.selectedVersion.charCodeAt(i) >= 48 && this.executorComp.selectedVersion.charCodeAt(i) <= 57)) {
                                        versionLength++;
                                    }
                                }

                                if (entityLength === this.executorComp.executor_name.length) {
                                    if (versionLength === this.executorComp.selectedVersion.length) {
                                        if (this.editFlag) {
                                            this.eventNameForAudit = 'sqlquery_edit_redeploy_clicked';
                                        } else {
                                            this.eventNameForAudit = 'sqlquery_create_deploy_clicked';
                                        }
                                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                                            const payloadToSend = {
                                                actions: response1
                                            };
                                            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                type: 'audit',
                                                id: localStorage.getItem('IdOfSession'),
                                                payload: payloadToSend
                                            });
                                        });
                                        this.loading = true;
                                        if (this.editFlag) {
                                            this.eventNameForAudit = 'sqlquery_edit_redeploy_success';
                                        } else {
                                            this.eventNameForAudit = 'sqlquery_create_deploy_success';
                                        }
                                        if (this.executorComp.selectedExecutorType.toString() === 'UNIFIEDQUERY') {
                                            this.executorModelPayload = this.getAPIExecutorModelForSQLQuery(this.executorModel);
                                            this.databaseName = this.database;

                                        } else if (this.executorComp.selectedExecutorType.toString() === 'QUERY') {
                                            this.executorModelPayload = this.getAPIExecutorModelForQuery();
                                            this.databaseName = this.database['db_name'];

                                        }

                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                            info: 'Connecting to the database',
                                            type: 'initial',
                                            icon: 'fa fa-code'
                                        }, timeStamp, action);
                                        if (this.testcase.length > 0) {
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Connecting to the database',
                                                type: 'success'
                                            }, timeStamp, action);
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Generating the API',
                                                icon: 'fa fa-code',
                                                type: 'success'
                                            }, timeStamp, action);


                                            let temp = [];

                                            let tempExecutors = [];
                                            let tempOrderBy = [];
                                            for (const item of this.testcase) {
                                                tempExecutors.push(item['executor']);
                                            }

                                            for (const item of this.orderByList) {
                                                const temp = item['name'] + ' ' + item['sortby'];
                                                tempOrderBy.push(temp);
                                            }
                                            this.executorForApi['executors'] = tempExecutors;
                                            this.executorForApi['fields'] = this.projectionAttributeList;
                                            this.executorForApi['join'] = this.query1;
                                            this.executorForApi['groupby'] = this.groupByList;
                                            this.executorForApi['orderby'] = tempOrderBy;
                                            this.executorForApi['condition'] = this.basicRulesetToSQL(this.query);
                                            this.executorForApi['condition_org'] = this.query;
                                            this.executorForApi['orderby_org'] = this.orderByList;

                                            temp.push(this.executorForApi);
                                            this.executorModelPayload.executors = temp;
                                            const gateways = this.executorComp.gatewayControl.value as string[];
                                            const gatewaySettings = [];
                                            if (gateways && gateways.length > 0) {
                                                for (const gateway of gateways) {
                                                    gatewaySettings.push({name: gateway});
                                                }
                                            }
                                            this.executorModelPayload.gatewaySettings = gatewaySettings;

                                            var that = this;
                                            if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                    info: 'Capturing changes made in API definition',
                                                    type: 'initial',
                                                    icon: 'fa fa-cloud-upload'
                                                }, timeStamp, action);
                                            }

                                            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async exec => {
                                                this.executor = exec;
                                                if (this.executor) {


                                                    if (this.executorComp.selectedExecutorType.toString() === 'SQLQUERY' &&
                                                        this.executor['source'] === this.code.trim() &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_display_name'], this.orig_executor['executor_display_name']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_description'], this.orig_executor['executor_description']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_category'], this.orig_executor['executor_category']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_category_group'], this.orig_executor['executor_category_group']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['service_provider'], this.orig_executor['service_provider']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_method_type'], this.orig_executor['executor_method_type']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['dataroot'], this.orig_executor['dataroot']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['prerequisites'], this.orig_executor['prerequisites']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['responseAttributes'], this.orig_executor['responseAttributes']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['response'], this.orig_executor['response']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['attributeMappings'], this.orig_executor['attributeMappings']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['block_attributes'], this.orig_executor['block_attributes']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['workflow_credentials'], this.orig_executor['workflow_credentials']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['pathParams'], this.orig_executor['pathParams']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['queryParams'], this.orig_executor['queryParams']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['headers'], this.orig_executor['headers']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['mockResponses'], this.orig_executor['mockResponses']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['authModel'], this.orig_executor['authModel']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['requestBody'], this.orig_executor['requestBody'])) {
                                                        this.loading = false;
                                                        this.closeNonWSDialogBox();

                                                        if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                            this.loading = false;
                                                            await this.platform.delay(500);
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Capturing changes made in API definition',
                                                                type: 'fatal',
                                                                description: 'No changes to save for this SQL Query API.',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                            this.closeNonWSDialogBox();

                                                            this.redeployNewExecutor = false;

                                                        }

                                                    } else {

                                                        if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                            this.redeployNewExecutor = false;
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Capturing changes made in API definition',
                                                                type: 'success',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                        }

                                                        this.executorModelPayload['creationTime'] = exec['creationTime'];
                                                        this.setHeaders();
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                            info: 'Updating API Executor',
                                                            type: 'initial',
                                                            icon: 'fa fa-cloud-upload'
                                                        }, timeStamp, action);
                                                        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account_id, exec['id'], this.executorModelPayload).subscribe(async data => {
                                                            this.save = true;
                                                            this.platform.updateAPIAuditLog(this.partner, this.account_id, this.executorModelPayload['executor_name'], this.executorModelPayload['executor_version'], 'SQLQUERY', this.executorModelPayload, exec);

                                                            this.executor_name = this.executorModelPayload.executor_name;
                                                            this.selectedVersion = this.executorModelPayload.executor_version;
                                                            this.selectedExecutor = this.executorModelPayload.executor_method_type;
                                                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', data.status, data.statusText, '', this.executorModelPayload, data, this.router.url)).then(response => {
                                                                const payloadToSend = {
                                                                    actions: response
                                                                };
                                                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                    type: 'audit',
                                                                    id: localStorage.getItem('IdOfSession'),
                                                                    payload: payloadToSend
                                                                });
                                                            });
                                                            this.Blocks = [1, 2, 4];
                                                            const blockLength = this.Blocks.length;
                                                            const blockStart = this.BlockList[this.Blocks[0]];
                                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                            this.progress = blockStart;
                                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');


                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                                                info: 'Updating Gateway Settings for the API',
                                                                type: 'initial',
                                                                icon: 'fa fa-shield'
                                                            }, timeStamp, action);
                                                            await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [this.selectedExecutor], timeStamp, action);
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                                                info: 'Updating Gateway Settings for the API',
                                                                type: 'success',
                                                                icon: 'fa fa-shield'
                                                            }, timeStamp, action);
                                                            this.save = false;
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Updating API Executor',
                                                                type: 'success',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);


                                                            if (testMode === 'alltests') {
                                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                    info: 'Executing test-suites for API usages',
                                                                    icon: 'fa fa-check-square-o',
                                                                    type: 'initial',
                                                                    messageType: 'test-results'
                                                                }, timeStamp, action);
                                                                this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async response => {
                                                                    let suiteResponse: any;
                                                                    suiteResponse = response;

                                                                    if (suiteResponse.testsPassRate === 100) {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'success',
                                                                            messageType: 'test-results',
                                                                            description: 'Test Suite pass rate: 100%',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    } else {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'warning',
                                                                            description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                                            messageType: 'test-results',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.revertExecutorChanges(this.executor, this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    }
                                                                }, async error => {
                                                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                        info: 'Executing test-suites for API usages',
                                                                        icon: 'fa fa-check-square-o',
                                                                        type: 'error',
                                                                        messageType: 'test-results',
                                                                        description: 'Testsuite execution failed. Please try again.'
                                                                    }, timeStamp, action);
                                                                    await this.revertExecutorChanges(this.executor, this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);

                                                                });

                                                            } else if (testMode === 'force') {
                                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                    info: 'Executing test-suites for API usages',
                                                                    icon: 'fa fa-check-square-o',
                                                                    type: 'initial'
                                                                }, timeStamp, action);
                                                                this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async response => {
                                                                    let suiteResponse: any;
                                                                    suiteResponse = response;

                                                                    if (suiteResponse.testsPassRate === 100) {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'success',
                                                                            messageType: 'test-results',
                                                                            description: 'Test Suite pass rate: 100%',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    } else {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'warning-low',
                                                                            description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                                            messageType: 'test-results',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    }

                                                                }, error => {
                                                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                        info: 'Executing test-suites for API usages',
                                                                        icon: 'fa fa-check-square-o',
                                                                        type: 'error',
                                                                        description: 'Testsuite execution failed. Please try again.'
                                                                    }, timeStamp, action);
                                                                    this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                });
                                                            } else {
                                                                this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                            }
                                                            Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'SUCCESS', '', data.status, data, data.statusText, '')).then(response => {
                                                                this.auditListenerService.auditListener.emit({
                                                                    type: 'auditLog',
                                                                    category: 'isAuditForSQLQuery',
                                                                    payload: response
                                                                });
                                                            });

                                                        }, error => {

                                                            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', this.executorModelPayload, error.status, '', '', error.statusText)).then(response => {
                                                                this.auditListenerService.auditListener.emit({
                                                                    type: 'auditLog',
                                                                    category: 'isAuditForSQLQuery',
                                                                    payload: response
                                                                });
                                                            });

                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEPLOYMENT', {
                                                                info: 'Updating API Executor',
                                                                type: 'error',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                            if (this.editFlag) {
                                                                this.eventNameForAudit = 'sqlquery_edit_redeploy_failed';
                                                            } else {
                                                                this.eventNameForAudit = 'sqlquery_create_deploy_failed';
                                                            }
                                                            this.loading = false;
                                                            this.closeNonWSDialogBox();

                                                            let errorMessage = '';
                                                            if (error.error['message']) {
                                                                errorMessage = error.error.message;
                                                            } else {
                                                                let title = '';
                                                                if (this.editFlag) {
                                                                    title = 'Error while updating';
                                                                } else {
                                                                    title = 'Error while creating';
                                                                }
                                                                this.loading = false;
                                                                this.closeNonWSDialogBox();

                                                                errorMessage = error.error;
                                                            }
                                                            Promise.resolve(this.platform.generateActionPayloadForAudit(true, this.eventNameForAudit, 'ERROR', error.status, error.statusText, errorMessage, this.executorModelPayload, error, this.router.url)).then(response => {
                                                                const payloadToSend = {
                                                                    actions: response
                                                                };
                                                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                    type: 'audit',
                                                                    id: localStorage.getItem('IdOfSession'),
                                                                    payload: payloadToSend
                                                                });
                                                            });
                                                            this.save = false;
                                                        });
                                                    }
                                                } else {
                                                    this.setHeaders();


                                                    const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('account') + '.' + this.executor_name + '.' + this.selectedVersion + '.' + localStorage.getItem('sessionID') + '.' + timeStamp.toString() + '.' + 'deploy';

                                                    this.action = 'deploy';
                                                    const payload = {
                                                        'topic': topic,
                                                        'apiModel': this.executorModelPayload
                                                    };

                                                    this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, false, false, true, true).toPromise().then(response1 => {

                                                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                        this.loading = false;
                                                        if (this.showDialogOnNonWebsocketConnection) {
                                                            this.showDialogOnNonWebsocketConnection.close();
                                                        }
                                                        if (!this.websocketService.isOpen()) {
                                                            this.logVisible = true;
                                                            this.refreshLogCount++;
                                                        }
                                                    }, error => {

                                                        this.loading = false;
                                                        if (this.showDialogOnNonWebsocketConnection) {
                                                            this.showDialogOnNonWebsocketConnection.close();
                                                        }
                                                        if (!this.websocketService.isOpen()) {
                                                            this.logVisible = true;
                                                            this.refreshLogCount++;
                                                        }
                                                    });
                                                    // this.confPost.insertApiExecutorForPartnerAccount(this.partner, this.account_id, this.executorModelPayload).subscribe(async data => {
                                                    //     this.save = true;
                                                    //     this.platform.createAPIAuditLog(this.partner, this.account_id, this.executorModelPayload['executor_name'], this.executorModelPayload['executor_version'], 'SQLQUERY', this.executorModelPayload);
                                                    //     Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', data.status, data.statusText, '', this.executorModelPayload, data, this.router.url)).then(response => {
                                                    //         const payloadToSend = {
                                                    //             actions: response
                                                    //         };
                                                    //         this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                    //             type: 'audit',
                                                    //             id: localStorage.getItem('IdOfSession'),
                                                    //             payload: payloadToSend
                                                    //         });
                                                    //     });
                                                    //
                                                    //     this.executor_name = this.executorModelPayload.executor_name;
                                                    //     this.selectedVersion = this.executorModelPayload.executor_version;
                                                    //     this.selectedExecutor = this.executorModelPayload.executor_method_type;
                                                    //
                                                    //     await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion, false, true, [this.executorComp.selectedExecutor], timeStamp, action);
                                                    //     await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.executor_name, this.selectedVersion, 'SQLQUERY', true, timeStamp, action);
                                                    //
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                    //         info: 'Checking for testcases <br>Testcases found: 0',
                                                    //         icon: 'fa fa-check-square-o',
                                                    //         type: 'initial'
                                                    //     }, timeStamp, action);
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                    //         info: 'Checking for testcases <br>Testcases found: 0',
                                                    //         icon: 'fa fa-check-square-o',
                                                    //         type: 'success'
                                                    //     }, timeStamp, action);
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                    //         info: 'Generating Documentation for the executor',
                                                    //         type: 'initial',
                                                    //         icon: 'fa fa-book'
                                                    //     }, timeStamp, action);
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                    //         info: 'Generating Documentation for the executor',
                                                    //         type: 'success',
                                                    //         icon: 'fa fa-book'
                                                    //     }, timeStamp, action);
                                                    //
                                                    //     await this.platform.delay(1500);
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'DONE', {
                                                    //         info: '',
                                                    //         type: 'success',
                                                    //         icon: 'fa fa-check'
                                                    //     }, timeStamp, action);
                                                    //
                                                    //     Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'SUCCESS', '', data.status, data, data.statusText, '')).then(response => {
                                                    //         this.auditListenerService.auditListener.emit({
                                                    //             type: 'auditLog',
                                                    //             category: 'isAuditForSQLQuery',
                                                    //             payload: response
                                                    //         });
                                                    //     });
                                                    //
                                                    //     this.loading = false;
                                                    //     this.closeNonWSDialogBox();
                                                    //     this.Blocks = [1, 2, 4, 5];
                                                    //     const blockLength = this.Blocks.length;
                                                    //     const blockStart = this.BlockList[this.Blocks[0]];
                                                    //     const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                    //     this.progress = blockStart;
                                                    //     this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');
                                                    //     this.leftPanelDataListener.notifyWorkflowBuilder.emit(this.executorComp.executor_name + '_' + this.executorComp.selectedVersion);
                                                    //     this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                    // }, error => {
                                                    //     if (this.editFlag) {
                                                    //         this.eventNameForAudit = 'sqlquery_edit_redeploy_failed';
                                                    //     } else {
                                                    //         this.eventNameForAudit = 'sqlquery_create_deploy_failed';
                                                    //     }
                                                    //     this.loading = false;
                                                    //     this.closeNonWSDialogBox();
                                                    //
                                                    //
                                                    //     this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEPLOYMENT', {
                                                    //         info: 'Deploying API',
                                                    //         type: 'error',
                                                    //         description: 'Unknown error occured.',
                                                    //         icon: 'fa fa-cloud-upload'
                                                    //     }, timeStamp, action);
                                                    //
                                                    //     this.platform.openSnackBar('We are working on the feature to deploy SQL Query APIs onto Cloud... Meanwhile, please validate your designtime business use cases and let us know if you are interested in additional features.', 'Error', {
                                                    //         duration: 10000,
                                                    //         verticalPosition: 'top',
                                                    //         horizontalPosition: 'center'
                                                    //     });
                                                    //     let errorMessage = '';
                                                    //     if (error.error['message']) {
                                                    //         errorMessage = error.error.message;
                                                    //     } else {
                                                    //         let title = '';
                                                    //         if (this.editFlag) {
                                                    //             title = 'Error while updating';
                                                    //         } else {
                                                    //             title = 'Error while creating';
                                                    //         }
                                                    //         this.platform.openSnackBar(error.error, 'Error', {
                                                    //             duration: 10000,
                                                    //             verticalPosition: 'top',
                                                    //             horizontalPosition: 'center'
                                                    //         });
                                                    //         errorMessage = error.error;
                                                    //     }
                                                    //
                                                    //     Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', this.executorModelPayload, error.status, '', '', errorMessage)).then(response => {
                                                    //         this.auditListenerService.auditListener.emit({
                                                    //             type: 'auditLog',
                                                    //             category: 'isAuditForSQLQuery',
                                                    //             payload: response
                                                    //         });
                                                    //     });
                                                    //     Promise.resolve(this.platform.generateActionPayloadForAudit(true, this.eventNameForAudit, 'ERROR', error.status, error.statusText, errorMessage, this.executorModelPayload, error, this.router.url)).then(response => {
                                                    //         const payloadToSend = {
                                                    //             actions: response
                                                    //         };
                                                    //         this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                    //             type: 'audit',
                                                    //             id: localStorage.getItem('IdOfSession'),
                                                    //             payload: payloadToSend
                                                    //         });
                                                    //     });
                                                    // });
                                                    this.save = false;
                                                }
                                            });
                                        } else {
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Connecting to the database',
                                                description: 'Error occurred while deploying your UNIFIED QUERY API. Please make sure you have selected a API.',
                                                type: 'fatal'
                                            }, timeStamp, action);
                                            this.loading = false;
                                            this.closeNonWSDialogBox();
                                        }
                                    } else {
                                        this.loading = false;
                                        this.closeNonWSDialogBox();
                                        await this.platform.delay(1500);
                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                                            info: 'Checking for special characters in Executor version',
                                            type: 'fatal',
                                            description: 'Special characters are not allowed in Executor Version',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, action);
                                    }
                                } else {
                                    this.loading = false;
                                    this.closeNonWSDialogBox();
                                    await this.platform.delay(1500);
                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                                        info: 'Checking for special characters in Executor name',
                                        type: 'fatal',
                                        description: 'Special characters are not allowed in Executor Name',
                                        icon: 'fa fa-newspaper-o'
                                    }, timeStamp, action);
                                }
                            }
                        } else {
                            this.loading = false;
                            this.closeNonWSDialogBox();
                        }
                    } else {
                        this.loading = false;
                        this.closeNonWSDialogBox();
                        await this.platform.delay(1500);
                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                            info: 'Checking for special characters in Executor version',
                            type: 'fatal',
                            description: 'Special characters are not allowed in Executor version',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, action);
                    }
                });
            } else {
                this.loading = false;
                this.closeNonWSDialogBox();
                await this.platform.delay(1500);
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor name',
                    type: 'fatal',
                    description: 'Special characters are not allowed in Executor name',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
            }
        });
    }

    runTests() {

        this.testLoading = true;
        this.confPost.testAPITestsuiteWithUsages(this.partner, this.account_id, this.partnerKey, {
            executor_name: this.orig_executor.executor_name,
            executor_version: this.orig_executor.executor_version
        }).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = res;

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: {name: this.testSuiteResponse.name},
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 7000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error, 'Error while testing the API. Please try again after sometime.');

        });
    }

    async finishAPIDeployment(executor_name, executor_version, action, timeStamp, result = {completed: true, document: true}) {
        await this.platform.delay(500);
        if (result.completed) {
            if (result.document) {
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                await this.platform.delay(2000);
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, action);
            }

            this.orig_executor = JSON.parse(JSON.stringify(this.executorModelPayload));
            await this.platform.delay(1000);
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.DONE, {
                info: '',
                type: 'success',
                icon: 'fa fa-check'
            }, timeStamp, action);

        }
        this.loading = false;
        this.closeNonWSDialogBox();

    }

    async revertExecutorChanges(executor, executor_name, executor_version, action, timeStamp) {
        this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
            info: 'Reverting changes to API',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, action);
        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account_id, executor['id'], executor).subscribe(async data => {

            if (this.selectedExecutor !== executor.executor_method_type) {
                await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [executor.executor_method_type], timeStamp, action);
            }

            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'success'
            }, timeStamp, action);
            await this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        }, error => {
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'fatal'
            }, timeStamp, action);
            this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        });
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    listenToApiCreation(topic) {
        this.websocketService.listenToTopic(topic).subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data.body);
            }
        });
    }

    async createApiForSqlQuery(testMode = 'notests') {
        this.loading = true;
        this.logVisible = false;
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;


        this.logComponentRefresh = true;

        if (this.editFlag === true) {
            this.action = 'redeploy';
            this.eventNameForAuditLog = 'REDEPLOY';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_update;
        } else {
            this.action = 'deploy';
            this.eventNameForAuditLog = 'REDEPLOY';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_create;
        }


        this.isSqlPresent = false;


        // this.listenAPICreation(timeStamp, this.executorComp.executor_name, this.executorComp.selectedVersion, this.action);

        if ((this.executorComp && !this.executorComp.executor_name)
            || (this.executorComp && !this.executorComp.selectedVersion)
            || (this.executorComp && !this.executorComp.selectedExecutor)
            || (this.executorComp && !this.executorComp.executorCategory)) {

            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }

        } else {
            if (this.testcase) {
                if (this.editFlag === true) {
                    this.createOrUpdateApiWithCoreApi(timeStamp, testMode);
                } else {
                    if (this.executorComp.isAPIAlreadyPresentCheckCompleted === false) {
                        await this.executorComp.checkForExistingEntityAndExecutor();
                        if (this.executorComp.isAPIAlreadyPresent === false) {

                            this.createOrUpdateApiWithCoreApi(timeStamp);
                        } else {
                            this.loading = false;
                            if (this.showDialogOnNonWebsocketConnection) {
                                this.showDialogOnNonWebsocketConnection.close();
                            }
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'API already exists')).then(response => {
                                this.auditListenerService.auditListener.emit({
                                    type: 'auditLog',
                                    category: 'isAuditForSQLQuery',
                                    payload: response
                                });
                            });
                        }
                    }
                }
            } else {
                Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid database selection')).then(response => {
                    this.auditListenerService.auditListener.emit({
                        type: 'auditLog',
                        category: 'isAuditForSQLQuery',
                        payload: response
                    });
                });
                this.platform.openSnackBar('Select a valid database connection.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
            }
        }
    }

    download() {
        $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
        this.saveAsProject();
    }

    saveAsProject() {
        if (this.responseData !== null && this.responseData !== undefined) {
            const data = this.responseData;
            const fileName = 'download';
            const exportType = 'json';
            exportFromJSON({data, fileName, exportType});
        }
    }

    getStatusCodeStyle(val) {
        if (val < 400) {
            return 'status-ok';
        } else {
            return 'status-not-ok';
        }
    }

    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    typeOfval(val) {
        return typeof val;
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    manageProgress(target, showPanel) {
        if (this.progress <= 20) {
            this.loading = false;
            this.closeNonWSDialogBox();
            let apiKey = localStorage.getItem('apikey');
            const dialogRef = this.dialog.open(DialogComponent, {
                maxWidth: '95vw',
                data: {
                    type: 'bl',
                    save: true,
                    gatewayFullUrl: this.gatewayFullUrl,
                    Blocks: this.Blocks,
                    selectedVersion: this.selectedVersion,
                    showNextPanel: false,
                    partner: this.partner,
                    account: this.account_id,
                    selectedExecutor: this.selectedExecutor,
                    executor_name: this.executor_name,
                    apiKey: apiKey,
                    partnerKey: this.partnerKey
                }
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result === 'create') {
                    this.save = false;
                    await this.router.navigateByUrl('/querybuilder');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (result === 'edit') {
                    this.save = false;
                    this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                } else if (result === 'execute') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
                } else if (result === 'devex') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
                }
            });
            this.ngOnDestroy();
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up Business Logic API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    generateExecutorAgain() {
        window.location.reload();
    }

    getAttributeWait() {
        // this.enableQuerySection = true;
        this.enablequery = false;
        this.enablequery1 = false;
        const that = this;
        setTimeout(function () {
            that.getAttributeList1();
        }, 500);

    }

    copyMessage(event) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(event.target).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    getAttributeList1() {
        this.availableAttributeList = [];
        this.availableAttributeList1 = [];
        this.availableAttributeList2 = [];
        this.apiList1 = [];
        this.apiList2 = [];
        this.apiList3 = [];
        this.attributeList = [];
        if (!this.editFlag) {
            this.projectionAttributeList = [];
        }
        const that = this;
        this.enablequery = true;
        this.enablequery1 = true;
        that.config1.fields = {};
        that.config.fields = {};
        for (const item of that.testcase) {
            if (item['executor']['responseAttributes'] && item['executor']['responseAttributes'].length > 0) {
                const attributes = item['executor']['responseAttributes'];
                for (const attribute of attributes) {
                    const name = item['executor']['executor_name'] + '.' + attribute['attributeName'];
                    let type = 'string';
                    if (attribute['type'] !== null && (attribute['type'].toLowerCase() === 'integer' || attribute['type'].toLowerCase() === 'double')) {
                        type = 'number';
                    } else if (attribute['type'] !== null && (attribute['type'].toLowerCase() === 'boolean')) {
                        type = 'boolean';
                    } else {
                        type = 'string';
                    }
                    this.attributeList.push(name);
                    this.availableAttributeList.push(name);
                    this.availableAttributeList1.push(name);
                    if (!this.editFlag) {
                        this.projectionAttributeList.push(name);
                    }
                    this.apiList1.push(name);
                    this.apiList2.push(name);
                    this.apiList3.push(name);
                    that.config.fields[name] = {
                        name: name,
                        type: type
                    };
                }
            }
        }

        const fields = {};
        this.availableAttributeList.map((e) => {
            fields[e] = {
                name: e, type: 'category', options: this.availableAttributeList.map(a => {
                    return {name: a, value: a};
                })
            };
        });
        that.config1 = {fields: fields};
        if (!this.editFlag) {
            this.groupByList = [];
            this.orderByList = [];
            that.query = {
                condition: 'and',
                rules: []
            };
            that.query1 = {
                condition: 'join',
                rules: []
            };
        } else {
            this.availableAttributeList2 = [];
            for (const item of this.availableAttributeList) {
                if (!this.projectionAttributeList.includes(item)) {
                    this.availableAttributeList2.push(item);
                }
            }
            for (const item1 of this.groupByList) {
                if (this.availableAttributeList.includes(item1)) {
                    const index = this.availableAttributeList.indexOf(item1);
                    if (index > -1) {
                        this.availableAttributeList.splice(index, 1);
                    }
                }
            }
            for (const item2 of this.orderByList) {
                if (this.availableAttributeList1.includes(item2['name'])) {
                    const index = this.availableAttributeList1.indexOf(item2['name']);
                    if (index > -1) {
                        this.availableAttributeList1.splice(index, 1);
                    }
                }
            }
        }

    }

    showOptions(event: MatCheckboxChange, index): void {
        if (event.checked) {
            this.subscribersChecked.push(this.subscribersData[index]);
        } else {
            for (let i = 0; i < this.subscribersChecked.length; i++) {
                if (this.subscribersChecked[i]['email'] === this.subscribersData[index]['email']) {
                    this.subscribersChecked.splice(i, 1);
                }
            }
        }
    }

    getCategoriesEntitiesForPartner() {
        // if (this.categories.length === 0) {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            if (this.categories && this.categories.length > 0) {
                                this.DisplayApiByCategory = true;
                                this.DisplayCustomOperation = true;
                            } else {
                                this.DisplayApiByCategory = false;
                                this.DisplayCustomOperation = false;
                            }
                        }
                    });
                }
            });
        // }
    }

    getThirdPartyApiExecutorsByPartnerAccountType() {
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     // localStorage.setItem('dataAccessAPI' , JSON.stringify(this.apiExecutors));
        // });
        this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
            // this.thirdPartyApiExecutors = data;
            this.apisByCategory = data;
            for (let i = 0; i < this.apisByCategory.length; i++) {
                const tempDataAccess = [];
                const tempbusinessLogic = [];
                const tempsql = [];
                const tempworkflow = [];
                const tempdecision = [];
                for (let j = 0; j < this.apisByCategory[i]['executors'].length; j++) {
                    let temp: string;
                    this.apiList.push({
                        id: this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version'],
                        itemName: this.apisByCategory[i]['executors'][j]['executor_name'] + '_' + this.apisByCategory[i]['executors'][j]['executor_version']
                    });
                    this.apiList_copy.push({
                        id: this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version'],
                        itemName: this.apisByCategory[i]['executors'][j]['executor_name'] + '_' + this.apisByCategory[i]['executors'][j]['executor_version']
                    });
                    temp = '';
                    if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'API') {
                        tempDataAccess.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'BUSINESSLOGIC') {
                        tempbusinessLogic.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'SQLQUERY') {
                        tempsql.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'WORKFLOW') {
                        tempworkflow.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'THIRDPARTY') {
                        tempdecision.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    }
                }
                if (tempDataAccess.length > 0) {
                    this.dataAccess.push({'executors': tempDataAccess, 'category': this.apisByCategory[i]['category']});
                }
                if (tempbusinessLogic.length > 0) {
                    this.businessLogic.push({
                        'executors': tempbusinessLogic,
                        'category': this.apisByCategory[i]['category']
                    });
                }
                if (tempsql.length > 0) {
                    this.sql.push({'executors': tempsql, 'category': this.apisByCategory[i]['category']});
                }
                if (tempworkflow.length > 0) {
                    this.workflow.push({'executors': tempworkflow, 'category': this.apisByCategory[i]['category']});
                }
                if (tempdecision.length > 0) {
                    this.decision.push({'executors': tempdecision, 'category': this.apisByCategory[i]['category']});
                }
            }
        });
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }

    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    fetchExecutor(item) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
            this.executor = exec;
            this.httpUrl = this.executor.apiUrl;
            // this.executor_name = this.executor.executor_name;
            this.executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.executor_method_type = this.executor.executor_method_type;
            this.httpOperation = this.executor.executor_method_type;
            this.parameterData = this.executor.queryParams;
            this.pathParameter = this.executor.pathParams;
            this.authModel = this.executor.authModel;
            this.headersData = this.executor.headers;
            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            if (this.typeOf(this.requestBody) === 'array') {
                                this.rawRequestBody = this.requestBody[0].value;
                            } else if (this.requestBody === undefined || this.requestBody === null) {
                                this.requestBody = {};
                                // this.rawRequestBody = this.requestBody.value;
                            } else {
                                this.rawRequestBody = this.requestBody.value;
                            }
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = this.executor.requestBody;
            this.executors = this.executor.executors;

            const payload1 = {
                'executor': this.executor
            };
            this.confPost.getAttributeForUnifiedQueryAPI(payload1).subscribe(response2 => {
                const temp: any = response2;
                if (temp['data'] && temp['data'].length > 0) {
                    this.executor.responseAttributes = temp['data'];
                } else {
                    if (this.executor.responseAttributes !== null) {
                        this.apiByDefinition = this.executor.responseAttributes;
                    }
                }
                this.addTestCase(this.executor);
                loaderDialog.close();

            }, error1 => {
                if (this.executor.responseAttributes !== null) {
                    this.apiByDefinition = this.executor.responseAttributes;
                }
                this.addTestCase(this.executor);
                loaderDialog.close();

            });
        });
    }

    typeOf(object) {
        let stringConstructor = 'test'.constructor;
        let arrayConstructor = [].constructor;
        let objectConstructor = ({}).constructor;

        if (object === null) {
            return 'null';
        }
        if (object === undefined) {
            return 'undefined';
        }
        if (object.constructor === stringConstructor) {
            return 'String';
        }
        if (object.constructor === arrayConstructor) {
            return 'array';
        }
        if (object.constructor === objectConstructor) {
            return 'object';
        }
        {
            return 'don\'t know';
        }
    }

    delete(i) {
        if (confirm('Are you sure want to remove this API')) {
            this.testcase.splice(i, 1);
            if (i > 0) {
                this.setCurrentTestCase(i - 1);
            } else {
                this.resetAttributes();
            }
            this.getAttributeWait();
        }
    }

    setCurrentTestCase(index) {
        this.currentTestCaseIndex = index;
        this.currentTestCaseName = this.testcase[index].name;
        const currentExecutor = this.testcase[index].executor;
        this.leftOperandString = currentExecutor['executor_type'] + '_' + currentExecutor['executor_name'] + '_' + currentExecutor['executor_version'] + '>';
        if (Object.keys(currentExecutor).length) {
            this.httpUrl = currentExecutor.apiUrl;
            // this.executor_name = currentExecutor.executor_name;
            this.executor_version = currentExecutor.executor_version;
            this.executor_type = currentExecutor.executor_type;
            this.executor_method_type = currentExecutor.executor_method_type;
            this.httpOperation = currentExecutor.executor_method_type;
            this.parameterData = currentExecutor.queryParams;
            this.pathParameter = currentExecutor.pathParams;
            this.authModel = currentExecutor.authModel;
            this.headersData = currentExecutor.headers;
            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = currentExecutor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = currentExecutor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            if (this.typeOf(currentExecutor.requestBody) === 'array' && currentExecutor.requestBody[0] !== null) {
                                this.rawRequestBody = currentExecutor.requestBody[0].value;
                            } else if (currentExecutor.requestBody === undefined || currentExecutor.requestBody === null) {
                                this.requestBody = {};
                                // this.rawRequestBody = this.requestBody.value;
                            } else {
                                this.rawRequestBody = currentExecutor.requestBody.value;
                            }
                            // this.rawRequestBody = currentExecutor.requestBody.value;
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = currentExecutor.requestBody;
            this.executors = currentExecutor.executors;
            if (currentExecutor.responseAttributes !== null) {
                this.apiByDefinition = currentExecutor.responseAttributes;
            }
            this.executor = currentExecutor;
        } else {
            this.resetAttributes();
        }
        this.getSelectedRequestBodyType();
    }

    resetAttributes() {
        this.currentTestCaseName = '';
        this.httpOperation = '';
        this.httpUrl = '';
        this.headersData = [];
        this.requestBody = {};
        this.apiByDefinition = [];
    }

    addTestCase(executor) {
        const temp = {};
        temp['name'] = executor.executor_name;
        temp['executor'] = executor;
        let isExist = false;
        for (const item of this.testcase) {
            if (item['name'] === executor.executor_name) {
                isExist = true;
                break;
            }
        }
        if (!isExist) {
            this.testcase.push(temp);
            // this.platform.openSnackBar('API selected', 'Success', {
            //     duration: 3000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        } else {
            this.platform.openSnackBar('API already selected', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        this.assert = [];
        // this.resetAttributes();
        this.setCurrentTestCase(this.currentTestCaseIndex);
        this.getAttributeWait();
    }

    getSelectedRequestBodyType() {
        const headers = this.headersData;
        if (!headers.length) {
            this.requestBodySelected = 'none';
            this.rawRequestBody = {};
            this.formData = [];
        }
        for (const header of headers) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        this.formData = this.requestBody.value;
                        this.formDataTrue = true;
                        this.formURLEncodedTrue = false;
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        this.formData = this.requestBody.value;
                        this.formDataTrue = false;
                        this.formURLEncodedTrue = true;
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        if (this.typeOf(this.requestBody) === 'array' && this.requestBody[0] !== null) {
                            this.rawRequestBody = this.requestBody[0].value;
                        } else if (this.requestBody === undefined || this.requestBody === null) {
                            this.requestBody = {};
                            // this.rawRequestBody = this.requestBody.value;
                        } else {
                            this.rawRequestBody = this.requestBody.value;
                        }
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }

    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    toggleExecutorWithID(ev, id) {
        const targetId = 'cat' + id;
        $(targetId).hasClass('in') ? $(targetId).removeClass('in') : $(targetId).addClass('in');
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
            );
        }
    }

    moveAttributes() {
        if (this.availableAttributeList.length > 0) {
            for (const item of this.availableAttributeList) {
                this.groupByList.push(item);
            }
        }
        this.availableAttributeList = [];
    }

    moveAttribute(i) {
        if (i !== undefined && i !== null && this.availableAttributeList.length > 0 && this.selectedAttributeType === 'available') {
            this.groupByList.push(this.availableAttributeList[i]);
            this.availableAttributeList.splice(i, 1);
            this.selectedAttribute = null;
            this.selectedAttributeType = '';
        }
        this.selectedAttribute = null;
        this.selectedAttributeType = '';
    }

    unSelectAttributes() {
        if (this.groupByList.length > 0) {
            for (const item of this.groupByList) {
                this.availableAttributeList.push(item);
            }
        }
        this.groupByList = [];
    }

    unSelectAttribute(i) {
        if (i !== undefined && i !== null && this.groupByList.length > 0 && this.selectedAttributeType === 'selected') {
            this.availableAttributeList.push(this.groupByList[i]);
            this.groupByList.splice(i, 1);
            this.selectedAttribute = null;
            this.selectedAttributeType = '';
        }
        this.selectedAttribute = null;
        this.selectedAttributeType = '';
    }

    moveAttributes1() {
        if (this.availableAttributeList1.length > 0) {
            for (const item of this.availableAttributeList1) {
                const obj = {
                    name: item,
                    sortby: 'ASC'
                };
                this.orderByList.push(obj);
            }
        }
        this.availableAttributeList1 = [];
    }

    moveAttribute1(i) {
        if (i !== undefined && i !== null && this.availableAttributeList1.length > 0 && this.selectedAttributeType1 === 'available') {
            const obj = {
                name: this.availableAttributeList1[i],
                sortby: 'ASC'
            };
            this.orderByList.push(obj);
            this.availableAttributeList1.splice(i, 1);
            this.selectedAttribute1 = null;
            this.selectedAttributeType1 = '';
        }
        this.selectedAttribute1 = null;
        this.selectedAttributeType1 = '';
    }

    unSelectAttributes1() {
        if (this.orderByList.length > 0) {
            for (const item of this.orderByList) {
                this.availableAttributeList1.push(item.name);
            }
        }
        this.orderByList = [];
    }

    unSelectAttribute1(i) {
        if (i !== undefined && i !== null && this.orderByList.length > 0 && this.selectedAttributeType1 === 'selected') {
            this.availableAttributeList1.push(this.orderByList[i].name);
            this.orderByList.splice(i, 1);
            this.selectedAttribute1 = null;
            this.selectedAttributeType1 = '';
        }
        this.selectedAttribute1 = null;
        this.selectedAttributeType1 = '';
    }

    moveAttributes2() {
        if (this.availableAttributeList2.length > 0) {
            for (const item of this.availableAttributeList2) {
                this.projectionAttributeList.push(item);
            }
        }
        this.availableAttributeList2 = [];
    }

    moveAttribute2(i) {
        if (i !== undefined && i !== null && this.availableAttributeList2.length > 0 && this.selectedAttributeType2 === 'available') {
            this.projectionAttributeList.push(this.availableAttributeList2[i]);
            this.availableAttributeList2.splice(i, 1);
            this.selectedAttribute2 = null;
            this.selectedAttributeType2 = '';
        }
        this.selectedAttribute2 = null;
        this.selectedAttributeType2 = '';
    }

    unSelectAttributes2() {
        if (this.projectionAttributeList.length > 0) {
            for (const item of this.projectionAttributeList) {
                this.availableAttributeList2.push(item);
            }
        }
        this.projectionAttributeList = [];
    }

    unSelectAttribute2(i) {
        if (i !== undefined && i !== null && this.projectionAttributeList.length > 0 && this.selectedAttributeType2 === 'selected') {
            this.availableAttributeList2.push(this.projectionAttributeList[i]);
            this.projectionAttributeList.splice(i, 1);
            this.selectedAttribute2 = null;
            this.selectedAttributeType2 = '';
        }
        this.selectedAttribute2 = null;
        this.selectedAttributeType2 = '';
    }

    changeSort(event, j) {
        this.selectedAttribute1 = null;
        this.selectedAttributeType1 = '';
        this.orderByList[j]['sortby'] = event.target.value;
    }

    valueToSQL(value) {
        switch (typeof value) {
            case 'string':
                return '\'' + value + '\'';
            case 'boolean':
                return value ? '1' : '0';
            case 'number':
                if (isFinite(value)) {
                    return value;
                }
        }
    }

    isDefined(value) {
        return value !== undefined;
    }

    basicRulesetToSQL(ruleset) {
        return ruleset.rules.map((rule) => {
            if (rule.rules) {
                return '(' + this.basicRulesetToSQL(rule) + ')';
            }
            let mod_field = '`' + rule.field.replace('.', '_') + '`';
            let column = mod_field,
                operator, value;

            switch (rule.operator) {
                case 'is null':
                case 'is not null':
                    operator = rule.operator;
                    value = '';
                    break;
                case 'in':
                case 'not in':
                    operator = rule.operator;
                    if (Array.isArray(rule.value) && rule.value.length) {
                        value = '(' + rule.value.map(this.valueToSQL).filter(this.isDefined).join(', ') + ')';
                    }
                    break;
                default:
                    operator = rule.operator;
                    value = this.valueToSQL(rule.value);
                    break;
            }

            if (this.isDefined(column) && this.isDefined(value) && this.isDefined(operator)) {
                return '(' + (column + ' ' + operator + ' ' + value).trim() + ')';
            }
        }).filter(this.isDefined).join(' ' + ruleset.condition + ' ');
    }

    createApiForUnifiedQuery() {

        if (this.executorComp.executor_name === undefined || this.executorComp.selectedVersion === undefined || this.executorComp.selectedExecutor === undefined || this.executorComp.executorCategory === undefined) {
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else if (this.testcase.length > 1 && this.query1['rules'].length === 0) {
            this.platform.openSnackBar('You have selected multiple APIs, Please add JOIN query to deploy the API.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else if (this.testcase.length === 0) {
            this.platform.openSnackBar('Please select API to deploy.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else {
            let tempExecutors = [];
            let tempOrderBy = [];
            for (const item of this.testcase) {
                tempExecutors.push(item['executor']);
            }

            for (const item of this.orderByList) {
                const temp = item['name'] + ' ' + item['sortby'];
                tempOrderBy.push(temp);
            }
            this.executorForApi['executors'] = tempExecutors;
            this.executorForApi['fields'] = this.projectionAttributeList;
            this.executorForApi['join'] = this.query1;
            this.executorForApi['groupby'] = this.groupByList;
            this.executorForApi['orderby'] = tempOrderBy;
            this.executorForApi['condition'] = this.basicRulesetToSQL(this.query);
            this.executorForApi['condition_org'] = this.query;
            this.executorForApi['orderby_org'] = this.orderByList;


            const executorModel = {
                'executor_type': this.executorComp.selectedExecutorType,
                'executor_name': this.executorComp.executor_name,
                'executor_version': this.executorComp.selectedVersion,
                'executor_display_name': this.executorComp.executor_display_name,
                'executor_description': this.executorComp.description,
                'executor_category': this.executorComp.executorCategory,
                'executor_method_type': this.executorComp.selectedExecutor,
                'published': true,
                'scopeOfAccess': this.executorComp.scopeSelected,
                'creationTime': Date.now(),
                'lastModifiedTime': Date.now(),
                'registeredAsIs': false,
                'queryParams': this.executorComp.queryParams,
                'headers': this.executorComp.headers,
                'mockResponses': this.executorComp.mockResponses,
                'authModel': this.executorComp.authModel,
                'requestBody': [],
                'source': this.code.trim(),
                'executors': [this.executorForApi],
                'partner': this.partner,
                'account_id': this.account_id,
                'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
                'dataroot': null,
                'responseAttributes': this.executorComp.responseAttributes,
                'attributeMappings': null,
                'response': null,
                'block_attributes': null
            };
        }
    }


    async executeAPI() {

        if (this.testcase.length === 0) {
            this.platform.openSnackBar('Please select  APIs to execute.', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else if (this.testcase.length > 1 && this.query1['rules'].length === 0) {
            this.platform.openSnackBar('You have selected multiple APIs, Please add JOIN query to execute the API.', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else {
            this.responseText = '';
            this.showResponseSection = true;
            this.viewResult = false;
            let payload = {};
            let tempExecutors = [];
            let tempOrderBy = [];
            for (const item of this.testcase) {
                tempExecutors.push(item['executor']);
            }

            for (const item of this.orderByList) {
                const temp = item['name'] + ' ' + item['sortby'];
                tempOrderBy.push(temp);
            }
            payload['executors'] = tempExecutors;
            payload['fields'] = this.projectionAttributeList;
            payload['join'] = this.query1;
            payload['groupby'] = this.groupByList;
            payload['orderby'] = tempOrderBy;
            payload['condition'] = this.basicRulesetToSQL(this.query);
            // console.log(payload);


            this.confPost.executeUnifiedQueryAPI(payload).subscribe(response2 => {
                this.viewResult = true;
                let temp = response2;
                if (response2) {
                    this.responseText = JSON.parse(temp['body']);
                } else {
                    this.responseText = [];
                }
            }, error1 => {
                this.viewResult = true;
                this.responseText = [];
            });
        }

    }

    // getAttributeAPI() {
    //     console.log(this.testcase[this.currentTestCaseIndex]['executor']);
    //     let payload = {
    //         'executor': this.testcase[this.currentTestCaseIndex]['executor']
    //     };
    //     this._service.getAttributesForApi(payload).subscribe(response2 => {
    //         console.log(response2);
    //     });
    // }

    selectAPI() {
        for (const item of this.selectedApis) {
            this.fetchExecutor(item.id);
        }
    }

    searchGroup(e) {
        const filterValue = e.toLowerCase();
        let temp = this.apiList1;
        temp = temp.filter(option => option.toLowerCase().includes(filterValue));
        this.availableAttributeList = temp;
        for (const item of this.groupByList) {
            const index = this.availableAttributeList.indexOf(item);
            if (index !== -1) {
                this.availableAttributeList.splice(index, 1);
            }
        }
    }

    closeGroup() {
        this.searchGroupBy = '';
        this.availableAttributeList = this.apiList1;
        for (const item of this.groupByList) {
            const index = this.availableAttributeList.indexOf(item);
            if (index !== -1) {
                this.availableAttributeList.splice(index, 1);
            }
        }
    }

    searchOrder(e) {
        const filterValue = e.toLowerCase();
        let temp = this.apiList2;
        temp = temp.filter(option => option.toLowerCase().includes(filterValue));
        this.availableAttributeList1 = temp;
        for (const item of this.orderByList) {
            const index = this.availableAttributeList1.indexOf(item['name']);
            if (index !== -1) {
                this.availableAttributeList1.splice(index, 1);
            }
        }
    }

    closeOrder() {
        this.searchOrderBy = '';
        this.availableAttributeList1 = this.apiList2;
        for (const item of this.orderByList) {
            const index = this.availableAttributeList1.indexOf(item['name']);
            if (index !== -1) {
                this.availableAttributeList1.splice(index, 1);
            }
        }
    }

    searchField(e) {
        const filterValue = e.toLowerCase();
        let temp = this.apiList3;
        temp = temp.filter(option => option.toLowerCase().includes(filterValue));
        this.availableAttributeList2 = temp;
        for (const item of this.projectionAttributeList) {
            const index = this.availableAttributeList2.indexOf(item);
            if (index !== -1) {
                this.availableAttributeList2.splice(index, 1);
            }
        }
    }

    closeField() {
        this.searchFieldBy = '';
        this.availableAttributeList2 = this.apiList3;
        for (const item of this.projectionAttributeList) {
            const index = this.availableAttributeList2.indexOf(item);
            if (index !== -1) {
                this.availableAttributeList2.splice(index, 1);
            }
        }
    }

    searchAPIs(e) {
        const filterValue = e.toLowerCase();
        let temp = this.apiList;
        temp = temp.filter(option => option['id'].toLowerCase().includes(filterValue));
        this.apiList_copy = temp;

    }

    closeSearchAPIs() {
        this.searchAPI = '';

    }

    addResponseAttribute() {
        const dialogRef = this.dialog.open(AddAttributeComponent, {
            minHeight: '45vh',
            maxHeight: '75vh',
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res && res !== undefined && res !== null) {
                let temp = res;
                this.testcase[this.currentTestCaseIndex].executor['responseAttributes'].push(temp);
                this.setCurrentTestCase(this.currentTestCaseIndex);
                this.getAttributeWait();
            }
        });
    }

    createNewApi() {
        const dialogRef = this.dialog.open(CreateApiComponent, {
            minHeight: '45vh',
            minWidth: '40vw',
            maxHeight: '95vh',
        });
        dialogRef.afterClosed().subscribe(res => {
            // console.log(res);
        });
    }

    createMarginRight() {
        document.getElementById('view:unified_query_builder').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:unified_query_builder').style.marginRight = '0px';
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    bQTabChanged(event) {
        this.selectedBQTab = event.index;
    }

    getAPIQueryBuilderTourSteps(): Array<TourStep>{
        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_INTRO_TITLE'),
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_INTRO_CONTENT'),
        });

        steps = steps.concat(this.platform.getExecutorTourSteps());

        steps.push({
                title: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_BROWSER_TITLE'),
                selector: '.tour-aqb-api-browser',
                content: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_BROWSER_CONTENT'),
                orientation: Orientation.Right
            },{
                title: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_BROWSER_SELECT_TITLE'),
                content: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_BROWSER_SELECT_CONTENT'),
            },{
                title: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_LIST_TITLE'),
                selector: '.tour-aqb-api-list-name',
                content: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_API_LIST_CONTENT'),
                orientation: Orientation.Right,
                action: (() => {this.fetchExecutor(this.apiList[0]['id'])})
            });

            steps = steps.concat(this.getDeveloperExperienceTourSteps());

            steps = steps.concat(this.getBuildQuerySteps());

            steps.push({
                title: this.platform.getProperty('EX_UNIFIED_QUERY_BUILDER_TEST_TITLE'),
                selector: '.tour-create-executor-save-api',
                content: this.platform.getProperty('EX_UNIFIED_QUERY_BUILDER_TEST_CONTENT'),
                orientation: Orientation.Left
            },{
                title: this.platform.getProperty('DP_UNIFIED_QUERY_BUILDER_TITLE'),
                selector: '.tour-create-executor-create-api',
                content: this.platform.getProperty('DP_UNIFIED_QUERY_BUILDER_CONTENT'),
                orientation: Orientation.Left
            },)

        return steps;
    }

    getDeveloperExperienceTourSteps(): Array<TourStep> {
        let steps: TourStep[] = [];

        steps.push({
            title: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_EXPERIENCE_TITLE'),
            selector: '.tour-developer-experience',
            content: this.platform.getProperty('ET_UNIFIED_QUERY_BUILDER_EXPERIENCE_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getBuildQuerySteps(): Array<TourStep> {
        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_PROJECTION_TITLE'),
            // selector: '.tour-aqb-bq-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_PROJECTION_CONTENT'),
            orientation: Orientation.Center,
            action: (() => this.selectedTab = 2)
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_FIELDS_TITLE'),
            selector: '.tour-aqb-selected-fields',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_FIELDS_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORED_FIELDS_TITLE'),
            selector: '.tour-ignored-fields',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORED_FIELDS_CONTENT'),
            orientation: Orientation.Left
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORE_TITLE'),
            selector: '.tour-aqb-ignore-button',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORE_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORE_ALL_TITLE'),
            selector: '.tour-aqb-ignore-all-button',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_IGNORE_ALL_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_TITLE'),
            selector: '.tour-aqb-select-button',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_TITLE'),
            selector: '.tour-aqb-select_all-button',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_WHERE_TAB_TITLE'),
            selector: '.tour-aqb-bq-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_WHERE_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => this.selectedBQTab = 1)
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_VIEW_TITLE'),
            selector: '.tour-aqb-where-view',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_VIEW_CONTENT'),
            orientation: Orientation.Left
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_JOIN_TAB_TITLE'),
            selector: '.tour-aqb-bq-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_JOIN_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => this.selectedBQTab = 2)
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_VIEW_TITLE'),
            selector: '.tour-aqb-join-view',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_VIEW_CONTENT'),
            orientation: Orientation.Left
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_GROUPBY_TAB_TITLE'),
            selector: '.tour-aqb-bq-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_GROUPBY_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => this.selectedBQTab = 3)
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_AVAILABLE_TITLE'),
            selector: '.tour-aqb-availaible',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_AVALILABLE_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_TITLE'),
            selector: '.tour-aqb-selected',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_CONTENT'),
            orientation: Orientation.Left
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_TITLE'),
            selector: '.tour-aqb-select',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_TITLE'),
            selector: '.tour-aqb-select-all',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_TITLE'),
            selector: '.tour-aqb-deselect',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_ALL_TITLE'),
            selector: '.tour-aqb-deselect-all',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_ALL_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_ORDERBY_TAB_TITLE'),
            selector: '.tour-aqb-bq-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_ORDERBY_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => this.selectedBQTab = 4)
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_AVAILABLE_TITLE'),
            selector: '.tour-aqb-availaible',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_AVALILABLE_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_TITLE'),
            selector: '.tour-aqb-selected',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECTED_CONTENT'),
            orientation: Orientation.Left
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_TITLE'),
            selector: '.tour-aqb-select',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_TITLE'),
            selector: '.tour-aqb-select-all',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_SELECT_ALL_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_TITLE'),
            selector: '.tour-aqb-deselect',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_CONTENT'),
            orientation: Orientation.Right
        },{
            title: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_ALL_TITLE'),
            selector: '.tour-aqb-deselect-all',
            content: this.platform.getProperty('GT_UNIFIED_QUERY_BUILDER_DESELECT_ALL_CONTENT'),
            orientation: Orientation.Right
        })
        return steps;
    }
}

@Component({
    selector: 'add-attribute-dialog',
    templateUrl: 'add-attribute.html',
    styleUrls: ['add-attribute.css'],
})
export class AddAttributeComponent implements OnInit {
    attributeName = '';
    attributeType = '';
    attributeDescription = '';
    types = [{'name': 'Integer', 'type': 'integer'},
        {'name': 'Date', 'type': 'date'},
        {'name': 'Timestamp', 'type': 'timestamp'},
        {'name': 'Boolean', 'type': 'boolean'},
        {'name': 'String', 'type': 'string'},
        {'name': 'Object', 'type': 'object'},
        {'name': 'Double', 'type': 'double'}

    ];
    data1: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddAttributeComponent>, public confPost: ConfService) {


    }

    ngOnInit(): void {
    }

    add() {
        this.data1 = {
            apiAccessPolicy: 'None',
            array: false,
            attributeName: this.attributeName,
            attributeType: 'None',
            autoIncrement: false,
            customType: false,
            dataStoragePolicy: 'None',
            defaultValue: null,
            description: this.attributeDescription,
            displayName: null,
            displayPolicy: null,
            precision: 0,
            previousAttributeName: null,
            required: true,
            size: 50,
            subType: [],
            type: this.attributeType,
            updateOption: 'none'
        };

        this.dialogRef.close(this.data1);

    }

    close() {
        this.dialogRef.close(this.data1);
    }

}

@Component({
    selector: 'create-api-dialog',
    templateUrl: 'create-api.html',
    styleUrls: ['create-api.css'],
})

export class CreateApiComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<CreateApiComponent>, public confPost: ConfService) {

    }

    ngOnInit(): void {
    }

    close() {
        this.dialogRef.close();
    }

}
